export default function getResource(label, vars = []) {
    const resources = {
        sectionTitle: 'Reservation Policies'
    };

    return resources[label];
}
